import React, { Fragment } from "react"
import {  Theme } from "@mui/system";
import { DataGrid, GridColDef,GridRowsProp} from '@mui/x-data-grid';
import { makeStyles } from 'tss-react/mui';
import List from "@mui/material/List";
import { Avatar, Box, Checkbox, CircularProgress, Divider, IconButton, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import {Pix,CreditCard,Money, Delete} from "@mui/icons-material"
import Alerts from "../alerts/Alerts";
import {ToolbarList } from "../toolbar"


const useStyles = makeStyles()((theme:Theme)=>({
    showList:{
      display:'none',
      [theme.breakpoints.down('sm')]:{
          display:'flex',
          flex:1,
      }
    },
    showTable:{
      display:'none',
      [theme.breakpoints.up('sm')]:{
          display:'flex',
          flex:1,
      }
    },  
  }));
export interface FieldsListProps{
    fieldPrimary:string;
    fieldSecondary:string;
    fieldSecondaryEnd:string;
    fieldIcon?:string;
}

interface ListTabProps {
    columns:GridColDef[],
    rows:Array<any>,
    handleClick:(row:any)=>void;
    fieldId:string;
    fieldList:FieldsListProps
    loading:boolean,
    checkbox?:{
        rowsSelect:Array<any>,
    }
    handleRemove?:(row:any)=>void;
   
}

export const ListTab = (props:ListTabProps) => {
    const { classes } = useStyles();
    const { columns,rows,handleClick,fieldId,fieldList,loading,checkbox,handleRemove } = props; 
    
    const findIcon = (iconText:string) => {
        switch (iconText) {
            case "Pix":
                return <Pix/>
            case "CreditCard":
                return <CreditCard/>
            default:
                return <Money/>
        }
    }
    return !loading&&rows.length>0?(
        <Box sx={{display:'flex', flex:1}}>                
            <div className={classes.showList}>
                <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                    {rows.map((row,idx)=>(
                        <Fragment key={idx}>
                            <ListItem 
                                key={idx}
                                alignItems="flex-start"
                                secondaryAction={
                                    <Stack spacing={1} direction={'row'} alignItems={'center'}>
                                        <Typography component={"span"}>
                                            {row[fieldList.fieldSecondaryEnd]}
                                        </Typography>
                                        {handleRemove&&(
                                            <IconButton color={'error'} edge="end" aria-label="delete" onClick={()=>handleRemove(row)}>
                                                <Delete />
                                            </IconButton>                                            
                                        )}
                                    </Stack>
                                }
                                
                            >
                                <ListItemButton role={undefined} onClick={()=>handleClick(row)} dense>
                                    {checkbox&&(
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={checkbox.rowsSelect.findIndex(select=>row[fieldId]===select[fieldId]) !== -1}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{ 'aria-labelledby': `checkbox-list-label-${row[fieldId]}` }}
                                        />
                                    </ListItemIcon>
                                    )}
                                    {fieldList.fieldIcon&&(
                                    <ListItemAvatar>
                                        <Avatar>
                                            {findIcon(row[fieldList.fieldIcon])}
                                        </Avatar>
                                    </ListItemAvatar>                                

                                    )}
                                    <ListItemText 
                                        primary={row[fieldList.fieldPrimary]}
                                        secondary={row[fieldList.fieldSecondary]}
                                    />

                                </ListItemButton>
                            </ListItem>
                            <Divider variant={fieldList.fieldIcon||checkbox?'inset':'middle'} component="li" />
                        </Fragment>
                    ))}
                </List>
            </div>
            <div className={classes.showTable}>
                <div style={{flexGrow: 1 }}>
                {fieldId?(
                    <DataGrid 
                        density={'compact'}
                        getRowId={(row)=>row[fieldId]}
                        columns={columns} 
                        rows={rows} 
                        onCellClick={(prm)=>handleClick(prm.row)} 
                        hideFooterPagination 
                        hideFooter
                        autoHeight
                    />

                ):(<>Field id nao informado</>)}
                </div>
            </div>
        </Box>

        ):(
            <Box sx={{display:'flex', flex:1,flexDirection:"column",justifyContent:"center", alignItems:"center"}}>  
                {loading?(
                    <Box sx={{display:"flex",flexDirection:"row"}}>
                        <CircularProgress />
                        <Typography component="h4">Aguarde...</Typography>
                    </Box>
                ):(
                    <>
                        <Typography component="h4">Registros não encontrados</Typography>
                        <PriorityHighIcon fontSize="large"/>    
                    </>
                )}
            
            </Box>
        )
}

interface ListTableViewProps extends ListTabProps{
    showAlert:boolean
    closeAlert:()=>void
    msg:string;
    status:string;
    title:string;
    buttonNovo:{
        show:boolean,
        onClick:()=>void;
        title:string;
    }  
    elevation?:number;


}
export const ListTableView = (props:ListTableViewProps) => {
    
    const { columns,rows,handleClick,fieldId,fieldList,loading,closeAlert,msg,showAlert,status,title,buttonNovo,elevation } = props;

    return (
        <Box
            sx={{display:"flex",flex:1,flexDirection:"column"}}
        >
            <Alerts 
                show={showAlert}
                handleClose={closeAlert}
                menssage={msg}
                tipoAlerta={status==="error"?"error":"info"}
             />

            <ToolbarList 
                color="inherit"
                buttonNovo={buttonNovo}
                title={title}
                elevation={elevation?elevation:1}

            />

            <ListTab 
                columns={columns}
                fieldId={fieldId}
                fieldList={fieldList}
                handleClick={handleClick}
                loading={loading}
                rows={rows}
            />

        </Box>
    )
}

